import { render, staticRenderFns } from "./PrescriptionSignatureActions.vue?vue&type=template&id=1012cb91&scoped=true&"
import script from "./PrescriptionSignatureActions.vue?vue&type=script&lang=js&"
export * from "./PrescriptionSignatureActions.vue?vue&type=script&lang=js&"
import style0 from "./PrescriptionSignatureActions.vue?vue&type=style&index=0&id=1012cb91&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1012cb91",
  null
  
)

export default component.exports